<template>
  <div class="resume-container">
    <!-- Display the uploaded resume image -->
    <img :src="require('@/assets/RBResume.png')" alt="Dr. Ravindra Bachate Resume" class="resume-image" />
    
    <!-- Download Button -->
    <div class="download-section">
      <a :href="resumePdf" download="Ravindra_Bachate_Resume.pdf" class="download-btn">
        <i class="material-icons">download</i>
        Download Resume
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResumePage",
  data() {
    return {
      resumePdf: require('@/assets/RBResume.pdf')
    }
  }
};
</script>

<style scoped>
/* Container Styling */
.resume-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--color-bg-subtle);
  margin-top: var(--nav-height);
  gap: var(--space-8);
}

/* Image Styling */
.resume-image {
  max-width: 80%;
  height: auto;
  box-shadow: var(--shadow-md);
  border-radius: var(--radius-md);
}

/* Download Button Styling */
.download-section {
  margin-top: var(--space-4);
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: 0.75rem var(--space-6);
  background-color: var(--color-primary);
  color: var(--color-bg-white);
  text-decoration: none;
  border-radius: var(--radius-md);
  font-weight: var(--font-semibold);
  transition: background-color var(--duration-slow) var(--ease-out), transform var(--duration-base) var(--ease-out), box-shadow var(--duration-base) var(--ease-out);
  box-shadow: var(--shadow-orange);
}

.download-btn:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-orange-lg);
  color: var(--color-bg-white);
}

.download-btn .material-icons {
  font-size: var(--text-base);
}
</style>